import Profile from "../../models/UserModel";
import { httpClient } from "../../../services/HttpClient";
import { generateUrl } from "../../../utils";
import { disconnectEcho } from "../../services/echoService";

export default {
    namespaced: true,
    state: {
        profile: new Profile(),
    },
    mutations: {
        setProfile(state: any, profile: Profile) {
            state.profile = profile;
        },
    },
    actions: {
        async fetchProfile({ commit }: any) {
            let response = await httpClient.get('/profile')

            let profile = new Profile(response.data.data);

            commit('setProfile', profile);
        },
        async logoutProfile() {
            await httpClient.post('/logout')

            disconnectEcho();

            window.location.href = generateUrl('app/authentication');
        }
    },
    getters: {
        profile: (state: any) => state.profile
    },
}